import styled from "styled-components";

import { Anchor } from "discover.medical.react-component-library";

export const StyledDiv = styled.div`
  ${({ theme }) => `
    height: 2.2rem;
    width: 11.25rem;
    border: 1px solid ${theme.colors.gray600};
    position: relative;
    padding: 1px;
    display: flex;
    background-color: white;
  `}
`;

export const StyledAnchor = styled(Anchor)`
  ${({ theme }) => `
    width: 100%;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    font-size: ${theme.font.size.sm};
    color: ${theme.colors.gray800};
    transition: background-color 0.15s linear;
    cursor: pointer;
    &:hover,
    &:focus {
        text-decoration: none;
      }
    }
  `}
`;
